import { render, staticRenderFns } from "./SliderEdit.vue?vue&type=template&id=44ee466f"
import script from "./SliderEdit.vue?vue&type=script&lang=ts"
export * from "./SliderEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports